import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { restoreSubscription } from 'src/storage/subscription';

const DEFAULT_VALUES = {
  subscriptionContext: {
    subId: '',
    token: '',
    flipperContext: {
      flipper: undefined,
      subscription_id: '',
      org_id: '',
      site_id: '',
      job_cost_v4: false,
    },
  },
  setSubscriptionContext: () => {},
};

const SubscriptionContext = createContext(DEFAULT_VALUES);

const SubscriptionContextProvider = ({ children }) => {
  const subscription = restoreSubscription();
  if (subscription) {
    DEFAULT_VALUES.subscriptionContext.subId = subscription.subId;
    DEFAULT_VALUES.subscriptionContext.token = subscription.token;
  }

  const [subscriptionContext, setSubscriptionContext] = useState(
    DEFAULT_VALUES.subscriptionContext
  );

  return (
    <SubscriptionContext.Provider
      value={{ subscriptionContext, setSubscriptionContext }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};

SubscriptionContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { SubscriptionContextProvider };
export default SubscriptionContext;
